import { cleanText } from './parser'

export type JsonObject = Record<string, any>

export function flattenJsonLd (value: any): JsonObject[] {
  if (!value) return []
  if (Array.isArray(value)) return value.flatMap(flattenJsonLd)
  if (typeof value !== 'object') return []

  const objects = [value as JsonObject]
  if (value['@graph']) objects.push(...flattenJsonLd(value['@graph']))
  return objects
}

export function readJsonLdObjects (): JsonObject[] {
  return Array.from(document.querySelectorAll<HTMLScriptElement>('script[type="application/ld+json"]'))
    .flatMap((script) => {
      const raw = script.textContent?.trim()
      if (!raw) return []

      try {
        return flattenJsonLd(JSON.parse(raw))
      } catch {
        return []
      }
    })
}

export function isBookObject (object: JsonObject): boolean {
  const type = object['@type']
  if (Array.isArray(type)) return type.some((item) => String(item).toLowerCase() === 'book')
  return String(type || '').toLowerCase() === 'book'
}

export function readBookJsonLd (): JsonObject | null {
  return readJsonLdObjects().find(isBookObject) || null
}

export function stringifyJsonLdValue (value: any): string {
  if (!value) return ''
  if (typeof value === 'string' || typeof value === 'number') return cleanText(String(value))
  if (Array.isArray(value)) return value.map(stringifyJsonLdValue).filter(Boolean).join(', ')
  if (typeof value === 'object') return stringifyJsonLdValue(value.name || value['@id'])
  return ''
}
